import UboxRewardShow from "components/view/ubox_reward_show";
import { uboxlist } from "lib/udiamond_reward_list";
import gameinhouse_openbox_bet from "lib/worker/api/gameinhouse_openbox_bet";
import React from "react";
import Img from "react-cloudimage-responsive";
import LayoutMaster from "../../../components/layout/layout_master";
import { useToasts } from "react-toast-notifications";
import { MaxButton } from "components/view/button";
import { useState } from "react";
import getinfo from "lib/worker/api/getinfo";
import SMPointView from "components/view/smpoint_view";
import { alertWithMessage } from "components/modal/message_modal";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

interface OpenUboxProps {
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function OpenUbox(props: OpenUboxProps) {
  const { addToast } = useToasts();
  const [loading, setLoading] = useState<boolean>(false);

  const bet = () => {
    if (!props.isLogin) {
      alertWithMessage("กรุณาเข้าสู่ระบบ ถึงจะสามารถเล่นเกมได้");
      return;
    }

    setLoading(true);
    gameinhouse_openbox_bet()
      .then((json) => {
        addToast(json.type, {
          appearance: "success",
          autoDismiss: true,
        });
        getinfo();
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เปิดกล่อง uBox ลุ้นรับเครดิตไปใช้แบบฟรีๆ",
        description: "รับ uDiamond จากการเปิดกล่อง",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-center">
          <span>เปิดกล่องลรับเครดิตและเพชรไปใช้แบบฟรีๆ</span>
        </h1>
        <p className="text-center">ของรางวัลสูงสุด 1,000 เครดิต</p>
        <div className="text-center">
          <SMPointView></SMPointView>
        </div>
        <div className="row center-content margin-top-20">
          <div className="view-background col-4 col-md-3 element">
            <Img className="full-width-image" src="ubox-snam.png"></Img>
          </div>
        </div>
        <div className="margin-bottom-20 col-8 col-md-4 col-lg-3 row center-row-content">
          <MaxButton
            title="เปิดกล่อง 50 uDiamond"
            className="text-center bg-invite button-glowing center-row-content"
            loading={loading}
            onClick={bet}
          ></MaxButton>
        </div>
        <div className="container">
          <div className="margin-top-20">
            <h4>
              <span>ของรางวัลที่ร่วมรายการ</span>
            </h4>
          </div>
        </div>
      </div>
      <div className="container">
        {(uboxlist ?? []).map((value) => {
          return (
            <>
              <UboxRewardShow
                List={`ของรางวัลที่ - ${value.list}`}
                Name={value.name}
                Pc={value.pc}
              ></UboxRewardShow>
            </>
          );
        })}
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    getinfo: state.member.getinfo,
    isLogin: state.member.isLogin,
  };
};

export default connect(mapStateToProps)(OpenUbox);
